module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events product-table",
    attrs: {
      "id": _vm.table.id
    }
  }, [(_vm.table.title) ? _c('h2', [_vm._v(_vm._s(_vm.table.title))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table is-narrow"
  }, [_c('thead', [_c('tr', _vm._l((_vm.table.config), function(event) {
    return _c('th', {
      domProps: {
        "innerHTML": _vm._s(event.title)
      }
    })
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.table.data), function(event) {
    return _c('tr', {
      staticClass: "field"
    }, _vm._l((_vm.table.config), function(field) {
      return _c('td', [_c('tablefield-' + field.type, {
        tag: "component",
        attrs: {
          "config": _vm._.get(field, 'config', {}),
          "data": _vm._.get(event, field.path, ''),
          "product": event
        }
      })], 1)
    }), 0)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18586382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TableReportEvents.vue
// module id = 659
// module chunks = 0